import { Permission } from '../../server/src/models/User';

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export interface AuthUser {
  id: string;
  _id: string; // Đảm bảo có cả id và _id để hoạt động với cả client và server
  name: string;
  email: string;
  role: UserRole;
  userPermissions: { permission: Permission }[];
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  name: string;
  email: string;
  password: string;
}

export interface AuthResponse {
  success: boolean;
  data: {
    token: string;
    user: AuthUser;
  };
  message?: string;
} 